import script from "./AppIndustry.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppIndustry.vue?vue&type=script&setup=true&lang=ts"

import "./AppIndustry.vue?vue&type=style&index=0&id=34f2b324&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f2b324"]])

export default __exports__